import { searchCreatorPendingAtom } from '@/features/discovery/stores/mutation-atom';
import { analyzeCommonality, type AnalyzeCommonalityRequest } from '../api';

import { useAbortableMutation } from '@/shared/hooks/use-abortable-mutation';

type AnalyzeCommonalityMutationRequest = {
  discoverySessionId: string;
  request: AnalyzeCommonalityRequest;
};

export function useAnalyzeCommonality() {
  return useAbortableMutation({
    mutationFn: ({ discoverySessionId, request }: AnalyzeCommonalityMutationRequest, signal) =>
      analyzeCommonality(discoverySessionId, request, signal),
    scope: { id: 'discovery:chat' },
    pendingAtom: searchCreatorPendingAtom,
    requestKey: 'discovery:analyze-commonality',
  });
}
